import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
type RecentPurchase = {
  name: string;
  location: string;
  minutesAgo: number;
};
const recentPurchases: RecentPurchase[] = [{
  name: 'Olivia Bennett',
  location: 'Austin, United States',
  minutesAgo: 4
}, {
  name: 'Emma Thompson',
  location: 'Toronto, Canada',
  minutesAgo: 7
}, {
  name: 'Sophie Williams',
  location: 'Manchester, United Kingdom',
  minutesAgo: 11
}, {
  name: 'Charlotte Green',
  location: 'Melbourne, Australia',
  minutesAgo: 14
}, {
  name: 'Isla McKenzie',
  location: 'Auckland, New Zealand',
  minutesAgo: 18
}, {
  name: 'Aoife Murphy',
  location: 'Dublin, Ireland',
  minutesAgo: 22
}, {
  name: 'Lerato Nkosi',
  location: 'Cape Town, South Africa',
  minutesAgo: 27
}, {
  name: 'Daniel Carter',
  location: 'Seattle, United States',
  minutesAgo: 31
}];
export function PurchaseNotifications() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number | undefined;
    let hideTimer: number | undefined;
    let nextTimer: number | undefined;
    const showNext = (delay: number) => {
      showTimer = window.setTimeout(() => {
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          nextTimer = window.setTimeout(() => {
            setIndex(current => (current + 1) % recentPurchases.length);
            showNext(0);
          }, 550);
        }, 5000);
      }, delay);
    };
    showNext(3000);
    return () => {
      if (showTimer) window.clearTimeout(showTimer);
      if (hideTimer) window.clearTimeout(hideTimer);
      if (nextTimer) window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  const purchase = recentPurchases[index];
  const initials = purchase.name.split(' ').map(part => part[0]).join('');
  return <div aria-live="polite" aria-atomic="true" className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-4" data-id="element-181">
      <AnimatePresence mode="wait" data-id="element-182">
        {visible && <motion.aside key={purchase.name} initial={{
        opacity: 0,
        y: 24,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 18,
        scale: 0.98
      }} transition={{
        type: 'spring',
        damping: 24,
        stiffness: 280
      }} className="pointer-events-auto relative flex w-full max-w-sm gap-3 rounded-xl border border-violet/25 bg-white p-3.5 shadow-xl" data-id="element-183">
            <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-navy text-xs font-bold text-white" data-id="element-184">
              {initials}
            </span>
            <div className="min-w-0 pr-5" data-id="element-185">
              <p className="text-[11px] font-semibold text-violet" data-id="element-186">
                {purchase.location}
              </p>
              <p className="mt-0.5 text-sm leading-snug text-navy" data-id="element-187">
                <strong data-id="element-188">{purchase.name}</strong>{' '}
                <span className="text-slate-600" data-id="element-189">
                  purchased Dance Fitness Instructor Pro
                </span>
              </p>
              <p className="mt-1 flex items-center gap-1 text-[10px] font-medium text-emerald" data-id="element-190">
                <BadgeCheckIcon size={12} data-id="element-191" />
                <ShoppingBagIcon size={11} data-id="element-192" />
                Verified Purchase • {purchase.minutesAgo} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => {
          setDismissed(true);
          setVisible(false);
        }} className="absolute right-2 top-2 rounded p-1 text-slate-400 hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-violet" aria-label="Dismiss recent purchase notification" data-id="element-193">
              <XIcon size={14} data-id="element-194" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}